import useAuth from './useAuth'
import useTenant from './useTenant'
import { fetchWithAuth } from './api';
import { reactive } from 'vue'

const assetContents = reactive({})

const getUrl = (path) => {
  return `user-assets/${useTenant().tenant.value.namespace}/files${path}`
}

const getPath = (uuid) => {
  return getUrl(`/${uuid}?token=${useAuth().token?.value}`)
}

const uploadAndGet = (formData) => {
  return upload(formData).then((res) => {
    return Promise.all(
      res.map(async (asset) => {
        return {
          ...asset,
          url: getPath(asset.uuid),
        }
      }),
    )
  })
}

const assetFetchWithAuth = (url = '', options = {}) => {
  const userAssetsUrl = getUrl(url)

  return fetchWithAuth(userAssetsUrl, options, true)
}

const upload = (formData) => assetFetchWithAuth('',
    {
      method: 'POST',
      body: formData,
    }
  ).then((res) => res.json())

const getAll = () => assetFetchWithAuth().then((res) => res.json())

const getByIds = (ids) => {
  return getAll().then((assets) =>
    assets.filter((asset) => ids.includes(asset.uuid)),
  )
}

const get = async (uuid) => {
  if (!assetContents[uuid]) {
    assetContents[uuid] = await assetFetchWithAuth(`/${uuid}`)
    .then((res) => res.blob())
  }

  return assetContents[uuid]
}


export default () => ({
  uploadAndGet,
  upload,
  get,
  getPath,
  getAll,
  getByIds,
})
